import React from 'react';
import { Phone } from 'lucide-react';

export const MobileCallButton = () => {
  return (
    <a
      href="tel:0970705863"
      className="fixed bottom-4 right-4 z-50 md:hidden bg-blue-600 text-white rounded-full p-4 shadow-2xl hover:bg-blue-700 transition-all duration-300 animate-pulse"
      aria-label="Appeler NHM Plomberie"
    >
      <Phone size={28} className="drop-shadow-lg" />
    </a>
  );
};
